/**
 * GameTypeToggleMock — iter87.520, redrawn iter87.524
 *
 * Themed re-creation of the real Trophy Tokens "Game Type" toggle
 * (Winner Take All vs. Podium · Top 3), structured to match
 * `RideStoryMock.jsx` exactly (same icon+title row, pill, paragraph,
 * footer, same font sizes) so the two peekaboo cards read as one
 * consistent family. iter87.522 briefly swapped this for a REAL
 * screenshot of the live Podium slider; iter87.523 tried shrinking
 * that further but the operator's actual complaint was the slider's
 * drag-handle circles looking sloppy at peek size, not the text size
 * — so this redraws the split as plain text instead of a bar/slider
 * graphic, same as this file originally did.
 */
import React from "react";

export default function GameTypeToggleMock() {
    return (
        <div className="w-full h-full bg-[#0a0a0a] p-3 flex flex-col gap-2 overflow-hidden">
            <div className="flex items-center gap-1.5">
                <span className="text-xs leading-none">🥇</span>
                <p className="font-display font-extrabold text-[9px] uppercase tracking-tight text-white leading-tight">
                    Game Type · Office Golf
                </p>
            </div>
            <span className="pill bg-heat/15 border-heat text-heat text-[7px] font-bold px-1.5 py-0.5 w-fit">
                Podium · Top 3
            </span>
            <p className="text-[8px] text-zinc-300 leading-snug">
                Office Golf splits the pot three ways instead of winner-take-
                all — 1st takes 50%, 2nd takes 30%, 3rd takes 20%.
            </p>
            <p className="text-[6.5px] text-zinc-600 mt-auto">
                Switch to Winner Take All anytime from Trophy Tokens settings.
            </p>
        </div>
    );
}

